import { isMobile } from 'components/Shared/responsive';
import { Cell, Grid } from 'components/Grid';
import connect from 'components/Shared/connect';
import styles from './benefits.scss';
import { BenefitsBlock } from 'models/BenefitsBlock';
import { SectionBlock } from 'models/SectionBlock';
import { hasElements, NO_ELEMENT, rm } from 'utils';
import { Section } from 'components/Section';
import Icon, { Icons, isIconName } from 'components/Shared/Icon';
import { Benefit } from 'models/Benefit';

type BenefitWithIcon = Omit<Benefit, 'iconName'> & { iconName: Icons };
interface MergedProps extends BenefitsBlock {
  isMobile: boolean;
  benefits: BenefitWithIcon[];
}

export const Benefits = connect<MergedProps, SectionBlock>(state => ({
  isMobile: isMobile(state)
}))(({ benefits, isMobile, ...props }: MergedProps) => {
  if (!hasElements(benefits)) return NO_ELEMENT;

  return (
    <Section {...props}>
      <Grid huge="8" desktop="6" large="5" tablet="4" phone="3">
        <div className={styles.benefits}>
          {benefits
            .filter(({ iconName }) => isIconName(iconName))
            .map(({ iconName, displayName }) => (
              <Cell className={styles.benefit} key={displayName}>
                <Icon icon={iconName} size="small" />
                <span>{rm(`${displayName}`)}</span>
              </Cell>
            ))}
        </div>
      </Grid>
    </Section>
  );
});
